import {
  BookOpen,
  Clock3,
  CreditCard,
  Download,
  LayoutDashboard,
  Library,
  Menu,
  Settings,
  User,
} from 'lucide-react';

import type { TemplateConfig } from '../catedge';

export const learnerShellConfig: TemplateConfig = {
  brand: {
    name: 'WhatImean',
    shortName: 'W',
    logoSrc: '/WIMLogo-trans1.png',
    logoAlt: 'WhatImean logo',
    versionLabel: 'Learner',
  },
  tenancy: 'disabled',
  navigation: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: LayoutDashboard,
      path: '/dashboard',
    },
    {
      id: 'situations',
      label: 'Situations',
      icon: BookOpen,
      path: '/learn/categories',
    },
    {
      id: 'saved',
      label: 'Saved',
      icon: Library,
      path: '/saved',
    },
    {
      id: 'downloads',
      label: 'Downloads',
      icon: Download,
      path: '/downloads',
    },
    {
      id: 'history',
      label: 'History',
      icon: Clock3,
      path: '/history',
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: Settings,
      path: '/settings',
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: User,
      path: '/profile',
    },
    {
      id: 'subscription',
      label: 'Subscription',
      icon: CreditCard,
      path: '/subscription',
    },
  ],
  quickActions: [
    { label: 'Dashboard', to: '/dashboard' },
    { label: 'Situations', to: '/learn/categories' },
    { label: 'Saved', to: '/saved' },
    { label: 'Downloads', to: '/downloads' },
    { label: 'History', to: '/history' },
    { label: 'Settings', to: '/settings' },
  ],
  bottomTabs: [
    {
      id: 'dashboard',
      label: 'Home',
      icon: LayoutDashboard,
      to: '/dashboard',
    },
    {
      id: 'situations',
      label: 'Learn',
      icon: BookOpen,
      to: '/learn/categories',
    },
    {
      id: 'menu',
      label: 'Menu',
      icon: Menu,
      action: 'menu',
    },
  ],
  routes: {
    login: '/login',
    dashboard: '/dashboard',
    account: '/profile',
  },
  appEnv: import.meta.env.MODE || 'development',
};
